var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoFinancials = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44933",
    "data-name": "Group 44933",
    transform: "translate(-948 -861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_Financial",
    "data-name": "icon/Financial",
    transform: "translate(948 861)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13939",
    "data-name": "Rectangle 13939",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon_Financial-2",
    "data-name": "icon/Financial",
    d: "M301.767,334.579h-9.232a.924.924,0,0,1-.742-.407.954.954,0,0,1-.107-.85l1.616-4.687a.925.925,0,0,1,.83-.618h6.361a.924.924,0,0,1,.868.684l1.292,4.687a.949.949,0,0,1-.152.818A.92.92,0,0,1,301.767,334.579Zm12.925,0H305.46a.924.924,0,0,1-.742-.407.954.954,0,0,1-.107-.85l1.616-4.687a.923.923,0,0,1,.848-.618h6.36a.924.924,0,0,1,.868.684l1.292,4.687a.948.948,0,0,1-.158.826A.92.92,0,0,1,314.692,334.579Zm-6.307-8.437h-9.462a.924.924,0,0,1-.742-.407.953.953,0,0,1-.107-.85l1.653-4.687a.924.924,0,0,1,.839-.618h6.462a.923.923,0,0,1,.923.684l1.32,4.687a.949.949,0,0,1-.152.818A.92.92,0,0,1,308.385,326.142Z",
    transform: "translate(-291.629 -314.35)",
    fill: "#00a1af"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoFinancials);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_financials.72fe08c4557cbd53f04bee8a45d016b7.svg";